<template>
  <div class="d-flex flex-wrap card-info">
    <input-field
      label="Name"
      label-position="top"
      class="px-1 col-12 col-sm-4 pt-1"
    >
      <div class="text-left overflow-hidden">
        {{ provider.name ? provider.name : '-' }}
      </div>
    </input-field>

    <input-field
      label="Provider Type"
      label-position="top"
      class="px-1 col-12 col-sm-4 pt-1"
    >
      <b-avatar
        v-b-tooltip.hover.bottom="`${changeType(provider.type)}`"
        size="42px"
        class="mr-1 provider-type-badge pull-up"
        :src="changeTypeSrc(provider.type)"
      />
      {{ changeType(provider.type) }}
    </input-field>

    <input-field
      label="Last Modified"
      label-position="top"
      class="px-1 col-12 col-sm-4 pt-1"
    >
      <span v-b-tooltip.hover.bottom="`${formatOffsetDateTime(provider.updateDate)}`">
        {{
          provider.updateDate ? `${timeSince(provider.updateDate)} ago` : '-'
        }}
      </span>
    </input-field>

    <input-field
      label="Webhook Url"
      label-position="top"
      class="px-1 col-12 pt-1"
    >
      <div class="text-left overflow-hidden">
        <a
          v-clipboard:copy="provider.webhookUrl"
          v-clipboard:success="copySuccess"
          class="webhook-url"
        >
          <span class="p-0 m-0">
            {{ provider.webhookUrl }}
          </span>
          <span class="copy-url">
            <GjIcon name="Copy" />
          </span>
        </a>
      </div>
    </input-field>
  </div>
</template>

<script>
export default {
  name: 'ProviderDetails',
  data() {
    return {
      /* eslint-disable global-require */
      googleChat: require('@/assets/svg/icons/google-chat.svg'),
      slack: require('@/assets/svg/icons/slack.svg'),
      discord: require('@/assets/svg/icons/discord.svg'),
      /* eslint-enable global-require */
    }
  },
  computed: {
    gettingProvider() {
      return this.$store.state.providers.gettingProvider
    },
    provider() {
      return this.$store.state.providers.provider
    },
  },
  methods: {
    copyUrl() {
      this.infoToast('Copied to clipboard!')
    },
    changeType(type) {
      if (type === 0) {
        return 'Google Chat'
      }
      if (type === 1) {
        return 'Slack'
      }
      if (type === 2) {
        return 'Discord'
      }
      return null
    },
    changeTypeSrc(type) {
      if (type === 0) {
        return this.googleChat
      }
      if (type === 1) {
        return this.slack
      }
      if (type === 2) {
        return this.discord
      }
      return null
    },
  },
}
</script>

<style lang="scss" scoped>
.card-info::v-deep {
  .card-header {
    padding: 16px 0;
  }
  .card-body {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 14px;
  }
  .provider-type-badge {
    background-color: #fff !important;
    border: 1px solid #f6f7f9;
  }
  .webhook-url {
    color: #1d79f2;
    &:hover {
      color: #0d6ce8;
    }
  }
}
</style>
